import { Input } from "reactstrap";
import {
  Button,
  Modal,
  Table
} from "react-bootstrap";

var formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'MAD',
});

const format = (price) => formatter.format(price)

export const ConfirmStockModal = ({show, products, handleClose, handleClick}) => {
  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Table id="invoice">
            <thead>
              <tr>
                <th className="border-0">Id</th>
                <th className="border-0">Name</th>
                <th className="border-0">Price</th>
                <th className="border-0">box quantity</th>
              </tr>
            </thead>
            <tbody>
              {products.map((product, index) => {
                if (product.checked && product.boxQuantity > 0)
                  return (
                    <tr key={index}>
                      <td>{product.id}</td>
                      <td>{product.name}</td>
                      <td>{format(product.price)}</td>
                      <td>{product.boxQuantity}</td>
                    </tr>
                  );
              })}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>Close</Button>
          <Button variant="primary" onClick={handleClick}>Add </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
